import { faPennant } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import { BodyText, SpaceWrapper, Tooltip } from 'ui-toolkit';

export const BankAccountTooltip: React.FC = () => (
  <Tooltip placement={'right'} tooltipContent={<BodyText>Bank account does not match</BodyText>}>
    <SpaceWrapper>
      <FontAwesomeIcon icon={faPennant} color={'red'} />
    </SpaceWrapper>
  </Tooltip>
);
